/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Studentsonlyfeature2Inputs */

const en_studentsonlyfeature2 = /** @type {(inputs: Studentsonlyfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students only`)
};

const de_studentsonlyfeature2 = /** @type {(inputs: Studentsonlyfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur für Studierende`)
};

/**
* | output |
* | --- |
* | "Students only" |
*
* @param {Studentsonlyfeature2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const studentsonlyfeature2 = /** @type {((inputs?: Studentsonlyfeature2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studentsonlyfeature2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_studentsonlyfeature2(inputs)
	return de_studentsonlyfeature2(inputs)
});
export { studentsonlyfeature2 as "studentsOnlyFeature" }